(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientResultMissingDataDetailController', PatientResultMissingDataDetailController);

    PatientResultMissingDataDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PatientResultMissingData', 'Compendium'];

    function PatientResultMissingDataDetailController($scope, $rootScope, $stateParams, previousState, entity, PatientResultMissingData, Compendium) {
        var vm = this;

        vm.patientResultMissingData = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:patientResultMissingDataUpdate', function(event, result) {
            vm.patientResultMissingData = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
